import { FC } from 'react';
import styled from 'styled-components';
import colors from '../../styles/colors';

const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 4px 12px;
  font-size: 14px;
  gap: 2px;

  & .user-row {
    display: flex;
    align-items: center;
  }

  & .user-label {
    color: #999;
    margin-right: 4px;
  }

  & .user-name {
    color: gold;
    font-weight: 600;
  }

  & .not-assigned {
    color: #999;
    font-style: italic;
  }
`;

interface WrestlerUserInfoProps {
  wrestlerData: {
    user?: { username: string; nickname_forum?: string } | null;
  };
}

const WrestlerUserInfo: FC<WrestlerUserInfoProps> = ({ wrestlerData }) => {
  if (!wrestlerData.user) {
    return (
      <UserInfoContainer className="box-name-user-wrestler">
        <span className="not-assigned">Nessun utente assegnato</span>
      </UserInfoContainer>
    );
  }

  const nicknameForum = wrestlerData.user.nickname_forum;
  const hasNicknameForum =
    typeof nicknameForum === 'string' && nicknameForum.trim() !== '';

  return (
    <UserInfoContainer className="box-name-user-wrestler">
      <div className="user-row">
        <span className="user-label">Utente Sul Sito:</span>
        <span className="user-name">{wrestlerData.user.username}</span>
      </div>
      {hasNicknameForum ? (
        <div className="user-row">
          <span className="user-label">Utente Sul Forum:</span>
          <span className="user-name">{nicknameForum}</span>
        </div>
      ) : null}
    </UserInfoContainer>
  );
};

export default WrestlerUserInfo;
